import { render, staticRenderFns } from "./LabelValueGrid.vue?vue&type=template&id=2220d8cc&scoped=true"
import script from "./LabelValueGrid.vue?vue&type=script&lang=js"
export * from "./LabelValueGrid.vue?vue&type=script&lang=js"
import style0 from "./LabelValueGrid.vue?vue&type=style&index=0&id=2220d8cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2220d8cc",
  null
  
)

export default component.exports